<div #wordCloudContainer class="pl-word-cloud flex w-full flex-col items-center gap-4">
  <ng-container *ngIf="isWordCloudEmpty()">
    <p class="text-lg text-pl-error">{{ 'blocks.wordCloud.empty' | translate }}</p>
  </ng-container>
  <ng-container *ngIf="!isWordCloudEmpty()">
    <h3 *ngIf="title" class="text-center">{{ title }}</h3>
    <angular-d3-cloud
      *ngIf="widthWordCloud()"
      [animations]="true"
      [data]="data()"
      [height]="300"
      [width]="widthWordCloud()"
      [padding]="5"
      font="Impact"
      [fontSizeMapper]="fontSizeMapper"
      [rotate]="rotateFn"
      [autoFill]="true"
    ></angular-d3-cloud>
  </ng-container>
</div>
